import React from 'react';
import { Grid } from '@material-ui/core/';
import GridInput from '../../core/components/inputs/GridInput';
import useContactDataProvider from './ContactDataProvider';
import { Loading } from 'react-admin';

/*
  Leftover from the original implementation. This validation has been moved
  to onSubmit in DistributionListContactDialog so we can make the deadline
  with the fix in TFS-155631. Should be improved (returned back to normal)
  in the next release.
*/
const validateCheckedBox = value => {
  if (Array.isArray(value) && value.length < 1) {
    return 'At least one Contact must be selected';
  }
  return undefined;
};

const UserEmailGridInput = props => {
  const choices = props.fetchedUsers;

  const isMupChild = sessionStorage.getItem('isMupChild') === 'true';

  if (choices && choices.length > 0) {
    choices.forEach(item => {
      item.userName = item.firstName + ' ' + item.lastName;
    });
  }

  let additionalColumns;
  if (isMupChild) {
    additionalColumns = [
      {
        name: 'userId',
        label: 'User ID'
      },
      {
        name: 'mupUserId',
        label: 'Login User ID'
      }
    ];
  } else {
    additionalColumns = [
      {
        name: 'userId',
        label: 'User ID'
      }
    ];
  }

  return choices && choices.length > 0 ? (
    <GridInput
      {...props}
      label="Any selection made below will pull in the contact's information in the test email."
      choices={choices}
      optionValue={'email'}
      optionText={'userName'}
      optionValueLabel={'Email'}
      optionTextLabel={'User Name'}
      // The following props are required for GridInput to work.
      // These were passed from ReferenceArrayInput in the original implementation
      meta={{ touched: false, error: false }}
      resource="users"
      source="users"
      translate={undefined}
      translateChoice={false}
      // using the validate prop here wouldn't show a proper message,
      // moved validation to onSubmit for now, leaving this as a placeholder for further improvement
      onChange={validateCheckedBox}
      additionalColumns={additionalColumns}
    />
  ) : (
    <span>
      The distribution list is no longer valid. Please create a new one.
    </span>
  );
};

const FetchedContactGridInput = props => {
  const userIdList = props;
  const { fetchedUsers } = useContactDataProvider(userIdList);

  const preconditions =
    fetchedUsers && fetchedUsers.data && fetchedUsers.data.length > 0;
  return preconditions ? (
    <div>
      <Grid container spacing={1}>
        <Grid item sm={12}>
          <UserEmailGridInput fetchedUsers={fetchedUsers.data} />
        </Grid>
      </Grid>
    </div>
  ) : fetchedUsers && fetchedUsers.loading && !fetchedUsers.error ? (
    <Loading />
  ) : (
    // none of the selected contacts are visible to the logged in user
    <span>No contacts to be displayed.</span>
  );
};

const DistributionListContactSummary = props => {
  const { recipients } = props;
  let userIdList = [];

  // build a list of distinct user IDs to filter on
  recipients.forEach(recipient => {
    if (
      recipient &&
      recipient.userId &&
      !userIdList.includes(recipient.userId)
    ) {
      userIdList.push(recipient.userId);
    }
  });

  if (userIdList && userIdList.length > 0) {
    return <FetchedContactGridInput userIdList={userIdList} />;
  }
  return (
    <span>
      No contacts are selected. Please select some contacts before sending test
      email.
    </span>
  );
};

export default DistributionListContactSummary;
